import apiConfig from "../config/apiConfig";
import { toast } from "../utils/toast";
import { apiFetch } from "../apis/apiFetch";



export const messageService = {
  async create(data: any) {
    const res = await apiFetch(apiConfig.getResourceUrl("message"), {
      method: "POST",
      body: data.params,
    });

    const resJson = await res.json();
    console.log("Message create response:", resJson);
    // if (resJson.errCode === -1) toast.error("Error: " + resJson.message);
    return resJson;
  },

  async getByFilter(queryIdParam: string, args: string) {
    const response = await apiFetch(
      `${apiConfig.getResourceUrl("message")}?queryId=${queryIdParam}&args=${args}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    return data.resource || [];
  },
};
